<template>
  <div class="roster-report-list">
    <div class="animated fadeIn">
      <b-row>
        <b-col cols="12">
          <b-card header-tag="header" class="mt-2" footer-tag="footer">
            <div slot="header">
              <i className="fa fa-align-justify"></i><strong class="text-uppercase">{{ $t('side_bar.hit_rate_report') }}</strong>
            </div>
            <b-col cols="12">
              <div class="pull-right">
                <b-input-group v-bind:prepend="$t('report.date_range')">
                  <date-range-picker ref="drange" :startDate="filter.startAt" :endDate="filter.endAt" @update="updateDateRange" opens="left" :locale-data="date_locale" :ranges="ranges"></date-range-picker>
                </b-input-group>
              </div>
            </b-col>
            <b-col lg="3">
              <b-card :no-body="true">
                <b-card-body class="p-0 clearfix">
                  <i class="fa fa-bar-chart bg-primary p-4 px-5 font-2xl mr-3 float-left"></i>
                  <div class="h5 text-primary mb-0 pt-3">{{data.overall_hit_rate | formatPercent}}</div>
                  <div class="text-muted text-uppercase font-weight-bold font-xs">{{$t('report.overall_hit_rate')}}</div>
                </b-card-body>
              </b-card>
            </b-col>
            <b-col cols="12" class="text-center">
              <b-row>
                <div class="table-responsive">
                  <table class="table table-striped table-hover table-sm table-bordered">
                    <thead>
                      <tr>
                        <th scope="col" @click="sortingByKey(sortField.name.key)">
                          <span>{{$t('report.username')}}</span>
                          <i v-if="sortField.name.order === sortOrder.asc" class=" mr-2 fa fa-sort-amount-asc text-muted"></i>
                          <i v-else class=" mr-2 fa fa-sort-amount-desc text-muted"></i>
                        </th>
                        <th scope="col" @click="sortingByKey(sortField.averageTime.key)">
                          <span>{{$t('report.average_time')}}</span>
                          <i v-if="sortField.averageTime.order  === sortOrder.asc" class=" mr-2 fa fa-sort-amount-asc text-muted"></i>
                          <i v-else class=" mr-2 fa fa-sort-amount-desc text-muted"></i>
                        </th>
                        <th scope="col" @click="sortingByKey(sortField.longestTime.key)">
                          <span>{{$t('report.longest_time')}}</span>
                          <i v-if="sortField.longestTime.order  === sortOrder.asc" class=" mr-2 fa fa-sort-amount-asc text-muted"></i>
                          <i v-else class=" mr-2 fa fa-sort-amount-desc text-muted"></i>
                        </th>
                        <th scope="col" @click="sortingByKey(sortField.shortestTime.key)">
                          <span>{{$t('report.shortest_time')}}</span>
                          <i v-if="sortField.shortestTime.order  === sortOrder.asc" class=" mr-2 fa fa-sort-amount-asc text-muted"></i>
                          <i v-else class=" mr-2 fa fa-sort-amount-desc text-muted"></i>
                        </th>
                        <th scope="col" @click="sortingByKey(sortField.totalTransaction.key)">
                          <span>{{$t('report.transactions')}}</span>
                          <i v-if="sortField.totalTransaction.order  === sortOrder.asc" class=" mr-2 fa fa-sort-amount-asc text-muted"></i>
                          <i v-else class=" mr-2 fa fa-sort-amount-desc text-muted"></i>
                        </th>
                        <th scope="col" @click="sortingByKey(sortField.passedTransactions.key)">
                          <span>{{$t('report.passed_transactions')}}</span>
                          <i v-if="sortField.passedTransactions.order  === sortOrder.asc" class=" mr-2 fa fa-sort-amount-asc text-muted"></i>
                          <i v-else class=" mr-2 fa fa-sort-amount-desc text-muted"></i>
                        </th>
                        <th scope="col" @click="sortingByKey(sortField.averageHitRate.key)">
                          <span>{{$t('report.average_hit_rate')}}</span>
                          <i v-if="sortField.averageHitRate.order  === sortOrder.asc" class=" mr-2 fa fa-sort-amount-asc text-muted"></i>
                          <i v-else class=" mr-2 fa fa-sort-amount-desc text-muted"></i>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-if="data.hit_rate_data.length == 0">
                        <td class="text-center" colspan="7">
                          {{$t('message.no_data')}}
                        </td>
                      </tr>
                      <tr v-for="(item, index) in data.hit_rate_data" :key="index+0">
                        <td scope="row" class="text-left">
                          <span>{{item.name}}</span>
                        </td>
                        <td scope="row" class="text-left">
                          <span>{{item.average_time_string}}</span>
                        </td>
                        <td scope="row" class="text-left">
                          <span>{{item.longest_time_string}}</span>
                        </td>
                        <td scope="row" class="text-left">
                          <span>{{item.shortest_time_string}}</span>
                        </td>
                        <td scope="row" class="text-left">
                          <span>{{item.total_transaction}}</span>
                        </td>
                        <td scope="row" class="text-left">
                          <span>{{item.passed_transactions}}</span>
                        </td>
                        <td scope="row" class="text-left">
                          <span>{{item.average_hit_rate | formatPercent}}</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </b-row>
            </b-col>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>
<script>
import DataTable from '../../../components/Partials/DataTable'
import DateRangePicker from 'vue2-daterange-picker'

const ASC = 'asc';
const DESC = 'desc';

export default {
  name: 'HitRateReportList',
  components: {
    DataTable,
    DateRangePicker
  },
  data: function () {
    return {
      sortOrder: {
        asc: ASC,
        desc: DESC
      },
      sortField: {
        name: {
          key: 'name',
          order: ASC
        },
        averageTime: {
          key: 'average_time',
          order: ASC
        },
        longestTime: {
          key: 'longest_time',
          order: ASC
        },
        shortestTime: {
          key: 'shortest_time',
          order: ASC
        },
        totalTransaction: {
          key: 'total_transaction',
          order: ASC
        },
        passedTransactions: {
          key: 'passed_transactions',
          order: ASC
        },
        averageHitRate: {
          key: 'average_hit_rate',
          order: ASC
        }
      },
      filter: {
        startAt: this.$moment().format('YYYY-MM-DD'),
        endAt: this.$moment().format('YYYY-MM-DD')
      },
      data: {
        overall_hit_rate: 0,
        hit_rate_data: []
      }
    }
  },
  methods: {
    sortingByKey(key = 'name') {
      const transformedKey = this._.camelCase(key);
      const oldOrder = this.sortField[transformedKey].order;
      const newOrder = oldOrder === this.sortOrder.asc ? this.sortOrder.desc : this.sortOrder.asc;
      const sortedData = this._.sortBy(this.data.hit_rate_data, [key]);
      this.sortField[transformedKey].order = newOrder;
      return this.data.hit_rate_data = newOrder === this.sortOrder.asc ? sortedData : sortedData.reverse();

    },
    listHitRate () {
      let vm = this
      vm.axios.report.getHitRateReport('?start=' + this.$moment(this.filter.startAt + ' 00:00:00').utc().format('YYYY-MM-DD HH:mm:ss') + '&end=' + this.$moment(this.filter.endAt + ' 23:59:59').utc().format('YYYY-MM-DD HH:mm:ss'), function (response) {
        let data = response.data
        if (data) {
          vm.data = data;
          vm.data.hit_rate_data = Object.values(vm.data.hit_rate_data);
        }
      })
    },
    updateDateRange (val) {
      this.date = val
      this.filter.startAt = val.startDate != null ? this.$moment(val.startDate).format('YYYY-MM-DD') : this.$moment().subtract(7, 'days').format('YYYY-MM-DD')
      this.filter.endAt = val.endDate != null ? this.$moment(val.endDate).format('YYYY-MM-DD') : this.$moment().format('YYYY-MM-DD')
      this.listHitRate()
    }
  },
  created: function () {
    this.listHitRate()
  },
  computed: {
    date_locale: function () {
      let format = this.format_date_range_locale()
      if (this.$refs.drange) {
        this.$refs.drange.locale = format
      }
      return format
    },
    ranges: function () {
      return this.format_date_ranges()
    }
  },
  filters: {
    formatPercent (val) {
      return parseFloat(val).toFixed(2) + ' %'
    }
  }
}
</script>

<style scoped>
  th:hover {
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/views/admin/report/HitRateReport.vue